import { useState, useEffect } from 'react';
import {
  Box, Button, Typography, IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import i18n from '../common/i18n';
import imgPopUp from '../../assests/images/blog/popup-blog.png';
import '../../assests/css/blogPopUp.css';
import moneyFormatterWithoutDecimals from '../common/FormatterUtil';
import { getEnv, PERSONAL_ADWORDS_LOAN_URL } from '../../api/env';

const BlogPopUp = () => {
  const [visible, setVisible] = useState(false);
  const AMOUNT = 4000000;
  const INSTALLMENTS = 36;
  const PERSONAL_ADWORDS_LOAN_URL_VALUE = getEnv(PERSONAL_ADWORDS_LOAN_URL);

  const DELAY_INTERVAL_HOUR = 2;
  const DELAY_DISPLAY_S = 3;

  const LAST_SHOWN_KEY = 'popupLastShown';

  const DISPLAY_DELAY_MS = DELAY_DISPLAY_S * 1000;
  const DISPLAY_INTERVAL_MS = DELAY_INTERVAL_HOUR * 60 * 60 * 1000;

  useEffect(() => {
    const now = Date.now();
    const lastShown = localStorage.getItem(LAST_SHOWN_KEY);
    const shouldShow = !lastShown || now - parseInt(lastShown, 10) > DISPLAY_INTERVAL_MS;

    let timeout;
    if (shouldShow) {
      timeout = setTimeout(() => {
        localStorage.setItem(LAST_SHOWN_KEY, now.toString());
        setVisible(true);
      }, DISPLAY_DELAY_MS);
    }

    return () => ((timeout) ? clearTimeout(timeout) : undefined);
  }, []);

  const handleClick = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'BlogPopupClickToOnboarding',
    });
    window.open(PERSONAL_ADWORDS_LOAN_URL_VALUE, '_blank');
  };

  if (!visible) return null;

  return (
    <Box className="loan-popup">
      <Box className="loan-popup-content">
        <Box className="box-btn-close">
          <IconButton className="close-button" onClick={() => setVisible(false)}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Box className="loan-popup-body">
          <img src={imgPopUp} alt="monedas" className="loan-popup-image" />

          <Box className="loan-popup-text">
            <Typography variant="h6" fontWeight={700} className="popup-title">
              {i18n.offerPopUp.title}
            </Typography>
            <Typography variant="body2" className="popup-description">
              {i18n.offerPopUp.description
                .replace('{{amount}}', moneyFormatterWithoutDecimals.format(AMOUNT))
                .replace('{{installments}}', INSTALLMENTS)}
            </Typography>
            <Box className="loan-popup-buttons">
              <Button
                variant="contained"
                className="ButtonMagenta"
                onClick={() => handleClick()}
              >
                {i18n.offerPopUp.primaryButton}
              </Button>
              <Button className="ButtonSecondary" onClick={() => setVisible(false)}>
                {i18n.offerPopUp.secondaryButton}
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default BlogPopUp;
